module.exports = __webpack_public_path__ + "static/media/CH.8c5bcf2c.svg";